const mapUrls = (response) => {
  if (!response || !response.product_data.length) {
    return [];
  }
  return response.product_data.map((product) => product.url);
};

const fetchPredictiveResults = (query, callback) => {

  const options = { method: "GET", headers: { accept: "application/json" } };

  fetch(
    `https://api.clerk.io/v2/search/predictive?query=${query}&labels=["Header predictive"]&limit=3&attributes=["url","name"]&key=${window.theme.settings.clerkApiKey}&visitor=${window.sessionStorage.getItem('visitor_id') || 'auto'}`,
    options
  )
    .then((res) => res.json())
    .then((res) => {
      callback(mapUrls(res));
    })
    .catch((err) => console.error(err));
};

const fetchRecommendationResults = (type, callback, productId, label) => {
  const options = { method: "GET", headers: { accept: "application/json" } };

  let requestUrl = `https://api.clerk.io/v2/recommendations/${type}?labels=["${label}"]&limit=10&attributes=["url","name"]&key=${window.theme.settings.clerkApiKey}&visitor=${window.sessionStorage.getItem('visitor_id') || 'auto'}`;

  if ((type === "substituting" || type === "complementary") && productId) {
    requestUrl += `&products=[${productId}]`;
  }

  fetch(requestUrl, options)
    .then((res) => res.json())
    .then((res) => {
      callback(mapUrls(res));
    })
    .catch((err) => console.error(err));
};

const fetchProductResults = (paramsObj) => {
  const mappedUrls = paramsObj.urls.map((url) => `${url}?view=${paramsObj.view}`);
  const parser = new DOMParser();

  Promise.all(mappedUrls.map((u) => fetch(u)))
    .then((responses) => Promise.all(responses.map((res) => res.text())))
    .then((texts) => {
      const elements = texts.map((text) => {
        const newNode = parser.parseFromString(text, "text/html");
        const productElements = Array.from(newNode.body.children)[0];

        return productElements;
      });

      paramsObj.callback(elements);
    })
    .catch((err) => console.error(err));
};

const buildListFacet = (name, entries, checkedValues) => {
  const buildFacet = (entry, checkedValues) => {
    return `
      <li class="facets__item">
        <div class="checkbox facet-checkbox " tabindex="0">
          <input
           type="checkbox"
           name="Filter-facet-${name}-${entry.name}"
           value="${entry.value}"
           data-filter
           data-name="${name}"
           id="Filter-facet-${name}-${entry.name}"
           class="product-option__input"
           ${checkedValues && checkedValues.find((val) => val == entry.value) ? "checked" : ""}
          >
          <label for="Filter-facet-${name}-${entry.name}">${entry.name}</label>
        </div>
      </li>`;
  };

  const facetEntries = entries.map((entry) => buildFacet(entry, checkedValues));

  return `
    <ul class="facets__list list-unstyled" role="list">
      ${facetEntries.join("")}
    </ul>
  `;
};

const buildPriceFacet = (min, max, selectedMin, selectedMax) => {
  return `
    <price-range class="facets__price">
      <div class="facets__price-row">
        <span>${window.theme.settings.currencySymbol}</span>
        <div class="field facets__price-field" data-input-wrapper="">
          <label for="Filter-Price-GTE" class="field__label">${window.filterStrings.from}</label>
          <input
            type="number"
            id="Filter-Price-GTE"
            name="filter.v.price.gte"
            ${selectedMin ? `value="${selectedMin}"` : ""}
            placeholder="${min}"
            min="${min}"
            max="${max}"
            class="field__input"
            data-max="${max}"
          >
        </div>
      </div>
      
      <div class="facets__price-row">
        <span>${window.theme.settings.currencySymbol}</span>
        <div class="field facets__price-field" data-input-wrapper="">
          <label for="Filter-Price-LTE" class="field__label">${window.filterStrings.to}</label>
          <input
            type="number"
            id="Filter-Price-LTE"
            name="filter.v.price.lte"
            ${selectedMax ? `value="${selectedMax}"` : ""}
            placeholder="${max}"
            min="${min}"
            max="${max}"
            class="field__input"
            data-min="${max}"
          >
        </div>
      </div>
    </price-range>`;
};

const buildAccordionElement = (index, name, content, open) => {
  return `
    <details class="accordion__section facets__accordion-section ${
      open ? "is-active" : ""
    }" id="Filters-accordion-section-${index}" ${open ? "open" : ""}>
      <summary class="facets__accordion-btn h4 js-btn" id="Filters-accordion-button-${index}" role="button" aria-controls="Filters-accordion-dropdown-${index}" aria-expanded="false">
        ${name}
        <div class="facets__accordion-icon">
        <span class="icon">
          <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 4L17 12L9 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>
        </div>
      </summary>

      <div class="accordion__body facets__accordion-body slim-scrollbar" id="Filters-accordion-dropdown-${index}" style="height: ${
    open ? "auto" : "0px"
  };">
        ${Array.isArray(content) ? content.join("") : content}
      </div>
    </details>`;
};

const buildAccordion = (elements) => {
  return `
    <accordion-default class="accordion facets__accordion">
      ${elements.join("")}
    </accordion-default>
  `;
};

export {
  fetchPredictiveResults,
  fetchRecommendationResults,
  fetchProductResults,
  buildAccordion,
  buildAccordionElement,
  buildListFacet,
  buildPriceFacet,
};
